<template>
  <div class="lottery">
         <div class="lottery-num">当前可拆盲盒<span>{{chance}}</span>个</div>
         <div class="lottery-box" @click="$emit('clickLottery')"></div>
         <slot name="task"></slot>
         <div class="lottery-remark">
           <div v-if="cards.length<5">集齐5卡，必得88元</div> 
           <div class="lottery-get" v-else>
             <div class="lottery-title">恭喜你，集齐5张卡</div>
             <div class="lottery-coupon">
               <div class="lottery-money" v-if="!exchange" @click="$emit('clickPrize')">领取88元</div>
               <div class="lottery-receive" v-else>已领取</div>
             </div>
           </div>
         </div>
         <div class="lottery-logo">
           <div v-for="(item,index) in allCard" :key="index" class="lottery-card" >
              <img :src="item.brandImg" class="lottery-question" @click="gotoView(item.id)"/>
           </div>
         </div>
         <div class="lottery-my" @click="$emit('gotoMy')">
         </div>
  </div>
</template>

<script>
export default {
  props: {
    chance: {
      type: Number,
      default: 0,
    },
    exchange: {
      type: Boolean,
      default: false,
    },
    allCard: {
      type: Array,
      default() {
        return [];
      },
    },
    cards: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    gotoView(id) {
      if (id && id !== 999) {
        this.$emit('gotoView', id);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
 .lottery{
     background: url(~@this/assets/image-08.png)  no-repeat;
     background-size: 100% 100%;
     width: 674px;
     min-height: 638px;
     padding:100px 20px 20px;
     display: flex;
     flex-direction: column;
     align-items: center;
     .lottery-num{
       color: #ccd6d7;
       span{
         color: #f1cc73;
       }
     }
     .lottery-box{
     background: url(~@this/assets/image-07.png) no-repeat;
     background-size: 649px 177px;
     width: 649px;
     height: 177px;
     margin-top: 20px;
     }
     .lottery-remark{
       color: #69c7c3;
       margin: 15px 0;
       .lottery-get{
         display:flex;
         align-items: center;
         .lottery-title{
          color:#69c7c3;
         }
         .lottery-coupon{
           margin-left:60px;
           height:55px;
           width:200px;
           line-height:55px;
           text-align:center;
           background-color:#033f3d;
           color:#fccf6e;
           border-radius:55px;
           .lottery-receive{
            color:#6e6e6e;
            font-weight:800;
           }
         }
       }
     }
     .lottery-logo{
       width: 100%;
       height: 180px;
       display: flex;
       justify-content: space-around;
       align-items: center;
       .lottery-card{
         background-size: 100% 100%;
         width: 131px;
         height: 155px;
         display: flex;
         align-items: center;
         justify-content: center;
         .lottery-question{
           width: 100%;
           height: 100%;
         }
       }
     }
     .lottery-my{
      background: url(~@this/assets/image-01.png) no-repeat;
      background-size: 100% 100%;
      width: 221px;
      height: 53px;
      margin: 15px 0;
     }
 }
</style>
